import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '../../../../services/modal/modal.service';
import { BaseModalComponent } from '../../base-modal.component';
import { BasicTextInputComponent } from '../../../form/base-components/base-text-input/basic-text-input.component';
import { RadioGroupComponent } from '../../../form/base-components/radio-group/radio-group.component';
import { ApplicationService } from '../../../../services/application/application.service';

@Component({
  moduleId: module.id,
  selector: 'signer-email',
  templateUrl: './signer-email.component.html',
})
export class SignerEmailComponent extends BaseModalComponent implements OnInit {
  @ViewChild('hasSigner') hasSignerRadioInput: RadioGroupComponent;
  @ViewChild('signerEmail') signerEmailInput: BasicTextInputComponent;
  private insuredProp: string = 'customer.application.primaryPolicy.insured';
  private hasSignerProp: string = `${this.insuredProp}.hasSigner`;
  private insuredEmailProp: string = `${this.insuredProp}.person.email`;
  private signerEmailProp: string = `${this.insuredProp}.signer.email`;
  private signerFirstNameProp: string = `${this.insuredProp}.signer.firstName`;
  private signerMiddleNameProp: string = `${this.insuredProp}.signer.middleNamae`;
  private signerLastNameProp: string = `${this.insuredProp}.signer.lastName`;
  private signerSSNProp: string = `${this.insuredProp}.signer.SSN`;
  public signerFirstName: string;
  private signerMiddleName: string;
  private signerLastName: string;
  private signerSSN: string;

  YesNoOptions = [
    { value: 'false', description: 'Yes' },
    { value: 'true', description: 'No' },
  ];

  constructor(private appService: ApplicationService, modalService: ModalService) {
    super(modalService);
  }

  ngOnInit() {
    this.signerEmailInput.propertyName = this.signerEmailProp;
    this.hasSignerRadioInput.propertyName = this.hasSignerProp;
    this.signerFirstName = this.appService.getValue(this.signerFirstNameProp);
    this.signerMiddleName = this.appService.getValue(this.signerMiddleNameProp);
    this.signerLastName = this.appService.getValue(this.signerLastNameProp);
    this.signerSSN = this.appService.getValue(this.signerSSNProp);
  }

  confirm() {
    const { isError: signerEmailHasError, val: signerEmailVal } = this.signerEmailInput;
    const hasSignerVal = this.hasSignerRadioInput.selectedItem;

    if (!hasSignerVal || (hasSignerVal === 'true' && (signerEmailHasError || !signerEmailVal))) {
      return;
    }

    if (hasSignerVal === 'true') {
      this.appService.setValue(this.insuredEmailProp, signerEmailVal.toLowerCase());
      this.appService.submitValueAndFireTriggers(this.signerEmailProp, signerEmailVal.toLowerCase());
    }

    this.modalService.deactivate();
    this.appService.submitValueAndFireTriggers(this.signerFirstNameProp, this.signerFirstName);
    this.appService.submitValueAndFireTriggers(this.signerMiddleNameProp, this.signerMiddleName);
    this.appService.submitValueAndFireTriggers(this.signerLastNameProp, this.signerLastName);
    this.appService.submitValueAndFireTriggers(this.signerSSNProp, this.signerSSN);

    // If owner is signer and the ownerClassification is set to trust,
    // reset ownerClassification to null
    const ownerClassification = this.appService.getValue('customer.application.primaryPolicy.ownerClassification');
    if (hasSignerVal === 'false' && ownerClassification === 'trust') {
      this.appService.submitValueAndFireTriggers('customer.application.primaryPolicy.ownerClassification', null);
    }
    this.appService.appState.buildEnabledQuestions();
    this.appService.questionAnsweredSubject.next();
  }

  cancel() {}
}
